import { ArrowsClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowsClockwise";
import { Button } from "@volca/ui/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";

export const ReloadSidebarButton = ({
  onClick,
  entityName,
}: {
  onClick: () => void;
  entityName: string;
}) => (
  <Tooltip>
    <TooltipTrigger
      render={<Button variant="outline" size="sm" onClick={onClick} />}
    >
      <ArrowsClockwiseIcon />
      {entityName}
    </TooltipTrigger>
    <TooltipContent>
      The {entityName} was not displayed because it was still being processed.
      Click here to reload.
    </TooltipContent>
  </Tooltip>
);
